import { Box, Typography } from '@mui/material';
import { MenuOverlay } from './MenuOverlay';
// import { Link } from 'react-router-dom';
import { colors } from '../styles/colors';
import { linkBaseUrl } from '../constants/menuItems';
export const HoliDayType = () => {
  return (
    <>
      <MenuOverlay style={{ height: 'auto' }}>
        <Box
          sx={{
            '& ul': { listStyle: 'none' },
            '&>ul': { display: 'flex' },
            '& .heading': { fontSize: '20px' },
            '& a': {
              textDecoration: 'none',
            },
            '& .side_ul': {
              padding: '0 0 30px 30px',
              borderLeft: '1px solid #939292',
            },
            '& .bottom_title': {
              color: colors.basics.primary,
              pt: '15px',
            },
          }}
        >
          <Box>
            <Typography variant='subtitle2' className='heading' fontSize='20px' color='#303030'>
              Choose a holiday type
            </Typography>
            <Box
              display='flex'
              p='20px 0 0'
              justifyContent=' space-between'
              sx={{
                '& ul': {
                  width: '100%',
                  '& li ': {
                    width: '100%',
                    maxWidth: '296px',
                    padding: '0 0 1.25rem',
                    '& a': { fontSize: '16px', color: '#303030' },
                  },
                },
                'ul li a': {
                  '&:hover': {
                    color: colors.basics.primary,
                  },
                },
              }}
            >
              <ul className='first_ul'>
                <LiComponent name='Adult Only Holidays' href={`${linkBaseUrl}adult-only-holidays`} />
                <LiComponent name='Family Holidays' href={`${linkBaseUrl}family-holidays`} />
                <LiComponent name='Tours' href={`${linkBaseUrl}tours`} />
                <LiComponent name='Weddings' href={`${linkBaseUrl}weddings`} />
              </ul>
              <ul className='first_ul'>
                <LiComponent name='All Inclusive Holidays' href={`${linkBaseUrl}all-inclusive-holidays`} />
                <LiComponent name='Honeymoons' href={`${linkBaseUrl}honeymoons`} />
                <LiComponent
                  name='Twin & Multi Centre Holidays'
                  href={`${linkBaseUrl}twin-multi-centre-holidays`}
                />
              </ul>
              <ul className='first_ul'>
                <LiComponent name='Cruise Holidays' href={`${linkBaseUrl}cruise-holidays/cruises`} />
                <LiComponent name='Luxury Holidays' href={`${linkBaseUrl}luxury-holidays`} />
                <LiComponent name='Villa Holidays' href={`${linkBaseUrl}villa-holidays`} />
              </ul>
            </Box>
          </Box>
        </Box>
      </MenuOverlay>
    </>
  );
};
export const LiComponent = (props: any) => {
  const { name, href } = props;
  return (
    <li>
      <a href={href} target='_blank' rel='noreferrer'>
        {name}
      </a>
    </li>
  );
};
